import { jsxs as l, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as e } from "./index.es2447.js";
function H({ size: V = e }) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: V,
      height: V,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.468262", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.7271 16.9373H26.2043V19.5631C26.2043 20.7057 25.2569 21.6321 24.0883 21.6321H16.0008C15.3384 21.6321 14.8006 22.1574 14.8006 22.8057V25.1509C14.1319 25.1146 13.6003 24.5577 13.6003 23.8763V19.9945C13.6003 18.3059 15.0001 16.9373 16.7271 16.9373Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M14.8006 25.1509C14.8236 25.1522 14.8469 25.1528 14.8702 25.1528H14.8006V25.1509Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M17.9657 34.0735H15.7311C14.2231 34.0735 13 35.1956 13 36.5791V39.3554H26.2044V36.5791C26.2044 35.1956 24.9814 34.0735 23.4727 34.0735H21.2388C20.9533 34.5839 20.3256 34.9405 19.6021 34.9405C18.8781 34.9405 18.2509 34.5839 17.9657 34.0735Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M30.8746 33.4382H39.0714C40.4543 33.4382 41.5749 34.4665 41.5749 35.735V39.3559H28.3711V35.735C28.3711 34.4665 29.4917 33.4382 30.8746 33.4382Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.6018 32.548C16.9503 32.548 14.8003 30.4457 14.8003 27.8531V21.6323H24.4034V27.8531C24.4034 30.4457 22.254 32.548 19.6018 32.548Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M14.8003 27.8531C14.8003 29.8699 16.1013 31.5901 17.9274 32.2546H17.802V33.4568C17.802 34.2728 18.6113 34.9405 19.6021 34.9405C20.5922 34.9405 21.4027 34.2728 21.4027 33.4568V32.2546H21.2765C23.1027 31.5901 24.4034 29.8699 24.4034 27.8531V26.327H24.5588C25.1364 26.327 25.604 25.8693 25.604 25.3051V23.7951C25.604 23.5731 25.4202 23.3928 25.1926 23.3928H24.4034V21.6323H16.0011C15.3381 21.6323 14.8003 22.1576 14.8003 22.8059V23.3928H14.012C13.7843 23.3928 13.6006 23.5731 13.6006 23.7951V25.3051C13.6006 25.8693 14.0682 26.327 14.6458 26.327H14.8003V27.8531Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.6235 31.824V33.4381L34.9726 34.5018L33.3218 33.4381V31.824",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.5292 36.397L34.9725 34.8755L33.4165 36.397L34.1404 39.3558H35.8053L36.5292 36.397Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36.7733 31.7847V33.222C36.7733 34.038 35.9628 34.7057 34.9727 34.7057C33.9825 34.7057 33.1726 34.038 33.1726 33.222V31.7847",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M30.1709 27.6186C30.1709 30.2112 32.3209 32.3135 34.9725 32.3135C37.6246 32.3135 39.7746 30.2112 39.7746 27.6186V25.8579H39.9294C40.507 25.8579 40.9746 25.4001 40.9746 24.8359V23.3259C40.9746 23.1039 40.7908 22.9231 40.5632 22.9231H39.7746V21.1631C39.7746 18.5694 37.6246 16.4683 34.9725 16.4683C32.3209 16.4683 30.1709 18.5694 30.1709 21.1631V22.9231H29.3823C29.1547 22.9231 28.9709 23.1039 28.9709 23.3259V24.8359C28.9709 25.4001 29.4385 25.8579 30.0161 25.8579H30.1709V27.6186Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M32.6429 28.5107C32.6795 28.4975 32.7163 28.4845 32.7533 28.4719C33.188 29.2393 34.0181 29.7587 34.9726 29.7587C35.9284 29.7587 36.7591 29.2386 37.1935 28.4702C37.2322 28.4834 37.2707 28.4969 37.3091 28.5107C37.5688 28.6045 37.8554 28.4699 37.9491 28.2101C38.0429 27.9504 37.9083 27.6638 37.6486 27.5701C36.8148 27.2692 35.9147 27.105 34.9759 27.105C34.0378 27.105 33.1365 27.2692 32.3032 27.5702C32.0435 27.664 31.909 27.9505 32.0028 28.2103C32.0966 28.47 32.3832 28.6045 32.6429 28.5107ZM34.9726 28.7587C35.4554 28.7587 35.8825 28.5425 36.1641 28.2071C35.7787 28.14 35.3817 28.105 34.9759 28.105C34.5685 28.105 34.1697 28.1403 33.7825 28.208C34.0641 28.5429 34.4907 28.7587 34.9726 28.7587Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.6709 21.1631C29.6709 18.2826 32.0555 15.9683 34.9725 15.9683C37.8899 15.9683 40.2746 18.2826 40.2746 21.1631V22.4231H40.5632C41.0577 22.4231 41.4746 22.8186 41.4746 23.3259V24.8359C41.4746 25.5672 40.9559 26.1659 40.2746 26.3196V27.6186C40.2746 29.6855 39.0459 31.4618 37.2733 32.2997V32.9382H39.0714C40.689 32.9382 42.0749 34.1507 42.0749 35.735V39.8559H27.8711V35.735C27.8711 34.1507 29.257 32.9382 30.8746 32.9382H32.6726V32.3C30.8999 31.4622 29.6709 29.6857 29.6709 27.6186V26.3196C28.9896 26.1659 28.4709 25.5672 28.4709 24.8359V23.3259C28.4709 22.8186 28.8878 22.4231 29.3823 22.4231H29.6709V21.1631ZM35.8511 35.0527C36.4149 34.8506 36.8905 34.4584 37.1221 33.9382H39.0714C40.2195 33.9382 41.0749 34.7823 41.0749 35.735V38.8559H36.4423L37.0826 36.2388L35.8511 35.0527ZM32.8237 33.9382C33.0552 34.4584 33.5306 34.8505 34.0943 35.0527L32.863 36.2388L33.5033 38.8559H28.8711V35.735C28.8711 34.7823 29.7265 33.9382 30.8746 33.9382H32.8237ZM33.6726 32.6559V33.222C33.6726 33.6758 34.1639 34.2057 34.9727 34.2057C35.7816 34.2057 36.2733 33.6756 36.2733 33.222V32.6557C35.8568 32.7588 35.4209 32.8135 34.9725 32.8135C34.5244 32.8135 34.0889 32.7588 33.6726 32.6559ZM34.9725 16.9683C33.734 16.9683 32.6224 17.4768 31.8395 18.2885C32.0175 18.7287 32.1173 19.2167 32.1173 19.7314C32.1173 20.9745 31.5409 22.0662 30.6709 22.6923V27.6186C30.6709 29.9245 32.5864 31.8135 34.9725 31.8135C37.3591 31.8135 39.2746 29.9245 39.2746 27.6186V22.6922C38.4047 22.0661 37.8284 20.9744 37.8284 19.7314C37.8284 19.2168 37.9281 18.7288 38.106 18.2887C37.3231 17.4769 36.2113 16.9683 34.9725 16.9683ZM40.2746 25.2401V23.4231H40.4746V24.8359C40.4746 24.9948 40.3983 25.1426 40.2746 25.2401ZM29.6709 23.4231V25.2401C29.5472 25.1426 29.4709 24.9948 29.4709 24.8359V23.4231H29.6709ZM33.9699 36.5551L34.9726 35.5747L35.9757 36.5552L35.4128 38.8558H34.5328L33.9699 36.5551Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M18.161 27.8752C18.0605 27.6179 17.7706 27.4908 17.5134 27.5913C17.2561 27.6917 17.129 27.9816 17.2294 28.2389C17.5966 29.1793 18.5191 29.8473 19.6018 29.8473C20.6849 29.8473 21.6075 29.1793 21.9747 28.2389C22.0751 27.9816 21.948 27.6917 21.6908 27.5913C21.4336 27.4908 21.1436 27.6179 21.0432 27.8752C20.8228 28.4396 20.2649 28.8473 19.6018 28.8473C18.9394 28.8473 18.3813 28.4397 18.161 27.8752Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.7271 16.4373C14.7346 16.4373 13.1003 18.0193 13.1003 19.9945V23.8763L13.1006 23.906V25.3051C13.1006 26.0363 13.6191 26.6349 14.3003 26.7887V27.8532C14.3003 29.9203 15.5293 31.6969 17.302 32.5346V33.4568C17.302 33.4961 17.3033 33.535 17.3057 33.5735H15.7311C13.9884 33.5735 12.5 34.8797 12.5 36.5791V39.8554H26.7044V36.5791C26.7044 34.8797 25.216 33.5735 23.4727 33.5735H21.899C21.9015 33.535 21.9027 33.4961 21.9027 33.4568V32.5343C23.6751 31.6963 24.9034 29.92 24.9034 27.8532V26.7889C25.585 26.6354 26.104 26.0366 26.104 25.3051V23.7951C26.104 23.2868 25.6862 22.8928 25.1926 22.8928H24.9034V22.0046C25.9442 21.6693 26.7043 20.7093 26.7043 19.5631V16.4373H16.7271ZM18.302 33.4568V32.8905C18.7182 32.9934 19.1538 33.0481 19.6018 33.0481C20.0503 33.0481 20.4862 32.9934 20.9027 32.8903V33.4568C20.9027 33.9104 20.411 34.4405 19.6021 34.4405C18.7929 34.4405 18.302 33.9107 18.302 33.4568ZM14.3003 22.8928H14.1003V19.9945C14.1003 18.5926 15.2656 17.4373 16.7271 17.4373H25.7043V19.5631C25.7043 20.4191 24.9914 21.1321 24.0883 21.1321H16.0008C15.5351 21.1321 15.1085 21.3182 14.7991 21.6218C14.492 21.9231 14.3003 22.34 14.3003 22.8059V22.8928ZM19.6018 32.0481C17.2158 32.0481 15.3003 30.1592 15.3003 27.8532L15.3006 22.8057C15.3006 22.6257 15.3757 22.458 15.5002 22.3349C15.6257 22.2109 15.8015 22.1323 16.0011 22.1323H23.9034V27.8532C23.9034 30.1592 21.9884 32.0481 19.6018 32.0481ZM24.9034 23.8928V25.7098C25.0274 25.6123 25.104 25.4642 25.104 25.3051V23.8928H24.9034ZM14.3003 25.7091V23.8928H14.1006V25.3051C14.1006 25.4638 14.1768 25.6116 14.3003 25.7091ZM21.507 34.5735C21.0759 35.1144 20.3475 35.4405 19.6021 35.4405C18.8561 35.4405 18.1282 35.1143 17.6974 34.5735H15.7311C14.4578 34.5735 13.5 35.5114 13.5 36.5791V38.8554H25.7044V36.5791C25.7044 35.5115 24.7467 34.5735 23.4727 34.5735H21.507Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
H.__tags = [];
export {
  H as MetricHouseholdAgeIcon
};
//# sourceMappingURL=index.es412.js.map
